'use client';

import Image from 'next/image';
import type { CSSProperties } from 'react';

const SIZES = { sm: 22, md: 28, lg: 40 } as const;

/**
 * Shared product brand lockup: the TNI seal (mabes_tni.png) + "PrimaVM" wordmark.
 * Replaces the old "MeetX" camcorder lockup everywhere so branding stays consistent
 * across login, dashboard, prejoin, custom-join, the in-meeting bar and recordings.
 */
export function Brand({
  size = 'md',
  withText = true,
  nameColor,
  className,
  style,
}: {
  size?: keyof typeof SIZES;
  withText?: boolean;
  nameColor?: string;
  className?: string;
  style?: CSSProperties;
}) {
  const dim = SIZES[size];
  return (
    <span
      className={className}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 8, ...style }}
    >
      <Image
        src="/images/mabes_tni.png"
        alt="Logo TNI"
        width={dim}
        height={dim}
        style={{ objectFit: 'contain', width: dim, height: dim, flex: 'none' }}
      />
      {withText && (
        <span className="mx-brand__name" style={nameColor ? { color: nameColor } : undefined}>
          PrimaVM
        </span>
      )}
    </span>
  );
}
